module.exports = {
  provideFullAddress: 'Du skal skrive din fulde adresse',
  changeEmail: 'Ja, erstat',
  dontChangeEmail: 'Nej, behold',
  yes: 'Ja',
  no: 'Nej',
  'go-back-wizard': 'Forrige trin',
  'next-step-wizard': 'Fortsæt',
  step: 'Trin',
  off: 'af',
  'first-step-wizard': 'Ja, lad os begynde',
  'next-step': 'Fortsæt',
  'last-step': 'Modtag uforpligtende tilbud',
  'go-back': 'Tilbage',
  understood: 'Super, jeg forstår!',
  'company-autocomplete-label': '',
  'company-placeholder': 'Virksomhed AS',
  'company-label': 'Firma',
  'address-placeholder': 'Gadenavn, husnummer, postnummer osv.',
  address_no_number_placeholder: 'Gade- eller vejnavn',
  'address-label': 'Adresse',
  'address-street-number-label': 'Husnummer',
  'address-street-number-placeholder': '1A',
  'address-no-street-number-label': 'Adressen har ikke et husnummer',
  'address-not-found': 'Finder ikke min adresse',
  'address-no-match': 'Ingen træf',
  'address-choose-from': 'Vælg blandt flere adresser',
  'address-invalid': 'Adressen er ikke gyldig',
  'address-missing-street-number': 'Mangler husnummer',
  address_alert: 'Indtastede du den rigtige adresse?',
  address_missing_city: 'Mangler sted',
  'same-address-warning':
    'Du har angivet samme adresse på din nye og gamle bopæl. Kontroller at oplysningerne er korrekte.',
  'zip-label': 'Postnummer',
  'zip-does-not-exist': 'Postnr. eksisterer ikke',
  'zip-warning': 'Er du sikker på at du har skrevet riktig postnummer?',
  zip_placeholder: '8000',
  'name-label': 'Navn',
  'date-label': 'Dato (6 cifre)',
  'date-format': 'ddmmåå',
  'birthdate-label': 'Fødselsdato (6 cifre)',
  'national-identity-label': 'Dit cpr-nummer',
  'national-identity-placeholder': '11 cifre',
  'national-identity-invalid': 'CPR-nummeret er ikke gyldigt',
  'national-identity-identical': 'Medlåntagers CPR-nummer kan ikke være identisk med hovedansøgers',
  'bank-account-label': 'Kontonummer',
  'measuring-id-invalid': 'Ikke gyldigt målepunkt-id',
  'bank-account-placeholder': '11 cifre',
  'bank-account-invalid': 'Kontonummeret er ikke gyldigt',
  'organization-identity-label': 'CVR-nummer.',
  'organization-identity-placeholder': '8 cifre',
  'organization-identity-invalid': 'Ikke gyldigt CVR-nr.',
  'date-invalid': 'Ikke gyldig dato',
  'name-placeholder': 'Anders And',
  'name-invalid': 'Navnet er ikke gyldigt',
  'email-alert-message': 'Har du skrevet rigtig e-mailadresse?',
  'email-label': 'E-mail',
  'email-placeholder': 'navn@domæne.dk',
  'email-does-not-exist': 'E-mailadressen eksisterer ikke',
  'email-invalid': 'E-mail er ikke angivet korrekt',
  email_did_you_mean: 'Mente du',
  'comment-label': 'Uddybende information',
  'comment-placeholder': 'Valgfri, eksempelvis information om ønsker, behov eller særlige hensyn.',
  'phone-alert-message': 'Har du angivet rigtigt nummer?',
  'phone-label': 'Telefon',
  'phone-invalid': 'Telefonnummeret er ikke gyldigt',
  'phone-must-begin-with-+': 'Skal begynde med +',
  'phone-foreign': 'Udenlandsk telefonnummer',
  'phone-placeholder': '12345678',
  'phone-foreign-placeholder-prefix': '+45 ',
  'error-x-numbers': 'Skal bestå af --x-- cifre',
  'error-x-letters': 'Skal bestå af --x-- tegn',
  'error-min-x-letters': 'Skal have mindst --x-- bogstaver',
  'error-min-rooms': 'Vælg mindst én',
  'error-min-x-numbers': 'Skal bestå af mindst --x-- cifre',
  'error-max-x-numbers': 'Skal bestå af maksimum --x-- cifre',
  'error-inbetween-numbers': 'Skal bestå af --x------y cifre',
  'error-must-consist-of-x-letters': 'Skal indeholde mindst --x-- bogstaver',
  'error-mandatory': 'Skal udfyldes',
  'error-choose': 'Vælg mindst --x-- mulighed',
  'error-min-age': 'Tilbud gives desværre kun til kunder over --x-- år',
  'error-must-accept': 'Skal godkendes',
  'error-only-digits': 'Kun tal',
  privacy:
    '<strong>Dit privatliv beskyttes:</strong> Vi behandler alle data i overensstemmelse med databeskyttelsesforordningen (GDPR).',
  'privacy-policy':
    '<h4>Persondatapolitik</h4><p>Dine persondata er vigtige for os hos --x--. Som bruger skal du føle dig tryg ved at de oplysninger, du opgiver, ikke bliver brugt til andet end det, du har givet samtykke til, samt at de opbevares sikkert.</p><p>De data, du udfylder, er det som udbyderne som minimum skal bruge for at kunne give dig konkrete tilbud baseret på dine behov. De bliver ikke brugt til noget andet end at give dig præcist sådanne tilbud i en fornuftigt tidsafgrænset periode, alt efter dine valg og præferencer for kommunikationsform og –tid, der er relevant, udover til det nødvendige administrative arbejde, der er knyttet til dette.</p><p>Alle data behandles af det norske IT-selskab Nettbureau AS, som ejer og driver --x--, ud over de aktuelle leverandører.</p><p>Personoplysninger om dig skal kun behandles for lovlige formål og vil blive slettet eller anonymiseret, når vi ikke længere har grundlag for at behandle dem.</p><p>Nettbureau skal sikre, at personoplysninger om dig er tilfredsstillende beskyttet.</p><p>Nettbureau sikrer kommunikation med brugerne ved hjælp af kryptering.</p> <p>Læs mere i vores <a href="--y--" target="__blank">fuldstændige persondatapolitik</a></p>',
  close: 'Luk',
  'vehicle-label': 'Nummerplade',
  'fetching-information': 'Henter oplysninger',
  reg_num_error: 'Indtast et gyldigt registreringsnummer',
  remove_car_number: 'Fjern bil nr.',
  remove_mc_number: 'Fjern motorcykel nr.',
  remove_home_number: 'Fjern indboforsikring nr.',
  add_car: 'Tilføj en bil',
  add_home: 'Tilføj indboforsikring',
  add_mc: 'Tilføj en motorcykel',
  error_radio_button: 'Skal vælge et felt',
  invalid_day: 'Ikke gyldig dato',
  invalid_day_in_month: 'Denne dato findes i ikke denne måned',
  invalid_month: 'Ikke gyldig måned',
  invalid_year: 'Ikke gyldigt år',
  label_birthdate: 'Fødselsdato',
  label_date: 'Dato',
  label_month: 'Måned',
  label_year: 'År',
  locale: 'da-DA',
  missing_date: 'Mangler dato',
  missing_month: 'Mangler måned',
  missing_year: 'Mangler år',
  'datepicker-button': 'Vælg dato',
  'date-alert-message': 'Har du indtastet datoen korrekt?',
  email_wrong_user_account: 'Er du sikker på at e-mail-brugerkonto er korrekt?',
  email_wrong_email_address: 'Er du sikker på at e-mail-adressen er korrekt?',
  not_valid_municipality: '',
  not_valid_state: '',
  remove_boat_number: 'Fjern båd nr.',
  add_boat: 'Tilføj en båd',
  'sms-verification-label': '',
  'sms-verification-tinyLabel': '',
  'sms-verification-error-message': '',
  'sms-verification-code-not-received-first': 'Modtog du ikke en kode? Klik ',
  'sms-verification-code-not-received-link': 'her',
  'sms-verification-code-not-received-last': ' for at få tilsendt en ny.',
  'sms-verification-code-is-sent-again': 'Koden er sendt på ny.',
  'sms-verification-code-retry-error':
    'For mange forespørgsler. Vent venligst 30 sekunder, før du prøver igen.',
  'drop-files-first': 'Slip filerne her eller',
  'drop-files-last': 'klik for at vælge et billede',
  add_more: ' Tilføj flere',
  'leazard-two-factor-header': 'Snart i mål',
  'leazard-two-factor-help-text':
    'Vi har sendt en kode via SMS til dig fra +47 59 44 45 00 for at bekræfte dit telefonnummer.',
  'leazard-two-factor-submit': 'Fuldfør',
  'leazard-two-factor-label': 'Skriv koden for at bekræfte.',
  'leazard-loading-text': 'Behandler oplysningerne',
  'recaptcha-disclaimer': 'Denne hjemmeside er beskyttet af reCAPTCHA.',
};
